export const HostServiceStatusEnum = {
    NOT_SUSCRIPTED: 'NOT_SUSCRIPTED',
    ACTIVE_SUSCRIPTION: 'ACTIVE_SUSCRIPTION',
    CANCELLED: 'CANCELLED',
    PENDING_ADMIN_APPROVAL: 'PENDING_ADMIN_APPROVAL',
};
